'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'circle-notch';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f1ce';
var svgPathData = ['M214.8 68.4C128.6 87.3 64 164.1 64 256 64 362 150 448 256 448s192-86 192-192c0-91.9-64.6-168.7-150.8-187.6L310.8 5.9C425.9 31 512 133.4 512 256 512 397.4 397.4 512 256 512S0 397.4 0 256C0 133.4 86.1 31 201.2 5.9l13.7 62.5z', ''];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleNotch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;